<template>
	<div class="loginbox">
		<!-- 语言切换（右上角） -->
		<div class="lang">
			<van-dropdown-menu :overlay="false" active-color="#D4AF37">
				<van-dropdown-item v-model="lang" :options="option" @change="Language" />
			</van-dropdown-menu>
		</div>

		<!-- 登录卡片 -->
		<div class="container">
			<div class="title">Login</div>

			<!-- 表单 -->
			<van-cell-group inset>
				<van-field v-model="loginform.username" clearable :placeholder="$t('login.username')" />
				<van-field v-model="loginform.password" :type="type" :placeholder="$t('login.password')"
					right-icon="closed-eye" @click-right-icon="openeye" />
			</van-cell-group>

			<!-- 登录按钮 -->
			<van-button class="btn" :loading="loading" :loading-text="$t('login.loging')" @click="login" block>
				{{ $t('login.login') }}
			</van-button>

			<!-- 底部链接 -->
			<div class="footer-text">
				<span class="reg" @click="toserver">{{ $t('login.serverurl') }}</span>
				&nbsp;|&nbsp;
				<span class="reg" @click="register">{{ $t('login.register') }}</span>
			</div>
		</div>
	</div>
</template>

<script>
//import Web3 from 'web3'; // 引入 Web3.js
// function setCookie(cname, cvalue, exdays) {
//   var d = new Date()
//   d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
//   var expires = 'expires=' + d.toUTCString()
//   document.cookie = cname + '=' + cvalue + '; ' + expires
// }
// setCookie('googtrans', '/auto/en', 100)
export default {
	data() {
		return {
			index_img_1: index_img_1,
			lang: localStorage.getItem('lang') || 'my',
			option: [{
				text: 'မြန်မာ',
				value: 'my'
			},
			{
				text: 'แบบไทย',
				value: 'th'
			},
			{
				text: 'English',
				value: 'en'
			},
			{
				text: 'русский язык',
				value: 'ru'
			},
			{
				text: 'Français',
				value: 'fr'
			},
			{
				text: 'Español',
				value: 'es'
			},
			{
				text: 'Italiano',
				value: 'it'
			},
			{
				text: '中文',
				value: 'zh'
			}
			],
			loginform: {
				username: '',
				password: ''
			},
			type: 'password',
			loading: false,
			checked: true,
			serverurl: ''
		}
	},
	created() {
		function getPar(par) {
			// 获取当前URL
			let localUrl = document.location.href
			// 获取要取得的get参数位置
			let get = localUrl.indexOf(par + '=')
			if (get === -1) {
				return false
			}
			// 截取字符串
			let getPar = localUrl.slice(par.length + get + 1)
			// 判断截取后的字符串是否还有其他get参数
			var nextPar = getPar.indexOf('&')
			if (nextPar !== -1) {
				getPar = getPar.slice(0, nextPar)
			}
			return getPar.slice(0, 2)
		}
		if (!localStorage.getItem('lang')) {
			localStorage.setItem('lang', getPar('lang'))
		}
		this.getserver()
		console.log(this.lang)
		this.getlang('token error', this.lang)
	},
	mounted() {
		// 页面加载完成后执行
		/*if (typeof window.ethereum !== 'undefined') {
			console.log('以太坊钱包已检测到！');
			// 初始化 Web3
			const web3 = new Web3(window.ethereum);
			// 请求用户授权连接其钱包
			window.ethereum
				.request({
					method: 'eth_requestAccounts'
				})
				.then((accounts) => {
					// 账户结果
					this.account = accounts[0];
					this.walletConnected = true;
					console.log('用户的以太坊地址：', this.account);
					const tokenstrs = window.localStorage.getItem('token')
					console.log("tokenstr:" + tokenstrs);
					if (tokenstrs) {
						this.$router.push('/index')
					} else {
						this.checkWallet(this.account);
					}
				})
				.catch((error) => {
					// 处理错误或用户拒绝请求
					console.error('用户拒绝访问账户', error);
				});
		} else {
			console.log('未检测到以太坊钱包插件，请考虑安装 Web3.0！');
		}*/
	},
	methods: {
		checkWallet(account) {
			// 调用后端接口
			this.$http.get('/home/index/walletlogin', {
				params: {
					uname: account
				},
			}).then((response) => {
				// 提取返回数据
				const dataa = response.data; // data 是后端返回的 JSON 数据部分
				console.log("dataa.code:", dataa.code); // 打印 code 值

				if (dataa.code === 200) {
					this.loading = true
					this.$http.get('/home/index/logins', {
						params: {
							uname: account
						},
					}).then((responsea) => {
						const data = responsea.data;
						console.log("data.code:", data.code); // 打印 code 值
						if (data.code === 200) {
							console.log("token:" + data.data.token)
							this.$toast.success(this.getlang(data.msg, this.lang))
							window.localStorage.setItem('token', data.data.token)
							this.$router.push('/')
						} else {
							this.$toast.fail(this.getlang(data.msg, this.lang))
						}
					})
					this.loading = false
				} else {
					// 失败逻辑
					this.$toast.fail(this.getlang(dataa.msg, this.lang)); // 显示错误消息
				}
			})
				.catch((error) => {
					console.error('请求失败：', error);
				});
		},

		openeye(event) {
			if (this.type === 'password') {
				event.target.className = 'van-icon van-icon-eye'
				this.type = 'text'
			} else {
				event.target.className = 'van-icon van-icon-closed-eye'
				this.type = 'password'
			}
		},
		// 获取客服链接
		async getserver() {
			this.serverurl = kefuurl
		},
		// 登陆
		async login() {
			if (!this.checked) {
				this.$toast.fail(this.$t('login.readagreement'))
				return false
			}
			if (this.loginform.username === '' || this.loginform.password === '') {
				this.$toast.fail(this.$t('login.complete'))
				return false
			}
			this.loading = true
			const {
				data
			} = await this.$http.post(
				'/home/index/login',
				this.loginform
			)
			if (data) {
				if (data.code === 200) {
					console.log(data.data.token)
					this.$toast.success(this.getlang(data.msg, this.lang))
					window.localStorage.setItem('token', data.data.token)
					this.$router.push('/')
				} else {
					this.$toast.fail(this.getlang(data.msg, this.lang))
				}
			}
			this.loading = false
		},
		// 用户协议
		agreement() {
			this.$router.push({
				path: '/agreement'
			})
		},
		// 忘记密码
		forget() {
			this.$router.push({
				path: '/forget'
			})
		},
		// 快速注册
		register() {
			this.$router.push({
				path: '/register'
			})
		},
		Language() {
			let lang = this.lang
			this.$i18n.locale = lang
			localStorage.setItem('lang', lang)

			// setCookie('googtrans', '/auto/en', 100)
			// setCookie('googtrans', '', -1111111111111)
			// if (this.$i18n.locale === 'zh') {
			//   this.$i18n.locale = 'en'
			//   localStorage.setItem('lang', 'en')
			//   // setCookie('googtrans', '/auto/en', 100)
			// } else {
			//   this.$i18n.locale = 'zh'
			//   localStorage.setItem('lang', 'zh')
			//   // setCookie('googtrans', '/auto/zh', 100)
			//   // this.$http.get('/home/index/language/zh').then(res => {
			//   //   console.log(res)
			//   // })
			// }
			// window.location.reload()
		},
		// 客服页面
		toserver() {
			window.location.href = this.serverurl
		}
	}
}
</script>

<style lang="less" scoped>
/* 整体居中、暗色背景 */
.loginbox {
	min-height: 100vh;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	background: #1c1c1c;
	color: #ffffff;
	position: relative;
	padding: 0 1rem;
}

/* 语言下拉 */
.lang {
	position: absolute;
	top: 0.8rem;
	right: 1rem;

	/deep/ .van-dropdown-menu__bar {
		background: transparent;
		box-shadow: none;
		height: 1.2rem;
	}

	/deep/ .van-dropdown-menu__title {
		color: #d4af37;
		font-size: 0.875rem;
	}

	/deep/ .van-popup {
		background: #1c1c1c;
		border-radius: 6px;
	}

	/deep/ .van-dropdown-item__option--active .van-dropdown-item__icon,
	/deep/ .van-dropdown-item__option--active .van-cell__title {
		color: #d4af37 !important;
	}
}

/* 登录卡片 */
.container {
	width: 100%;
	max-width: 400px;
	background: #f5f5dc;
	border-radius: 16px;
	padding: 24px;
	box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5);
	color: #1c1c1c;
}

/* 标题 */
.title {
	font-size: 1.5rem;
	text-align: center;
	margin-bottom: 24px;
	color: #b8860b;
}

.van-cell-group {
	background: transparent;
}

/* Vant 输入框微调 */
.van-cell,
.van-field__control {
	background: #ffffff;
	border-radius: 8px;
}

.van-field {
	margin-bottom: 16px;
	padding: 0;
	border: 1px solid #e59700;

	/deep/ .van-field__control {
		padding: 12px;
		font-size: 1rem;
		color: #1C1C1C;
		/* 文字改深色，避免白底看不见 */
		caret-color: #1C1C1C;
		/* 输入光标也改成深色 */
	}
}

.van-cell::after {
	border: none;
}

/* 登录按钮 */
.btn {
	background: #d4af37;
	border: none;
	border-radius: 8px;
	padding: 14px 0;
	font-weight: bold;
	color: #1c1c1c;
	transition: background 0.3s;

	&:hover {
		background: #b8860b;
	}
}

/* 底部文字 */
.footer-text {
	margin-top: 16px;
	font-size: 0.85rem;
	text-align: center;
	color: #b0b0b0;

	.reg {
		color: #d4af37;
		cursor: pointer;
	}

	span {
		cursor: pointer;
	}
}
</style>